import bci from "./BCI.svg";
import bankBICE from "./BICE.svg";
import bankChile from "./CHILE.svg";
import bankChile2 from "./CHILE.svg";
import consorcio from "./CONSORCIO.svg";
import coopeuch from "./COOPEUCH.svg";
import corpbanca from "./CORPBANCA.svg";
import bankEstado from "./ESTADO.svg";
import bankInternational from "./INTERNACIONAL.svg";
import internacional from "./INTERNACIONAL.svg";
import bankItau from "./ITAU.svg";
import ripley from "./RIPLEY.svg";
import santander from "./SANTANDER.svg";
import security from "./SECURITY.svg";
import scotiabank from "./SCOTIABANK.svg";
import falabella from "./FALABELLA.svg";
import prestamoTercero from "./PRESTAMOTERCERO.svg"
import prestamoAutomotriz from "./PRESTAMOAUTOMOTRIZ.svg"
import penta from "../banks/penta.png"
import tenpo from "../banks/tenpo.png"
import jpmorgan from "../banks/jpmorgan.png"
import mercadoPago from "../banks/mercadoPago.png"
import globalCard from "../banks/globalCard.jpg"
import bankiter from "./BANKITER.svg";

const banks = {
  bci,
  bankBICE,
  bankChile,
  bankChile2,
  consorcio,
  coopeuch,
  corpbanca,
  bankEstado,
  bankInternational,
  internacional,
  bankItau,
  ripley,
  santander,
  security,
  scotiabank,
  falabella,
  prestamoTercero,
  prestamoAutomotriz,
  penta,
  tenpo,
  jpmorgan,
  mercadoPago,
  globalCard,
  bankiter,
};

const bankLogo = (bank) => {
  if (banks[bank]) return banks[bank];
  return "";
};

export default bankLogo;
